import Id from './Id';
import Type from './Type';
import Status from './Status';
import InvoiceDates from './InvoiceDates';
import CreatorUser from './CreatorUser';
import InvoiceNumber from './InvoiceNumber';
import PaymentMethod from './PaymentMethod';
import Created from './Created';
import Updated from './Updated';
import LatestPaymentDate from './LatestPaymentDate';
import Currency from './Currency';
import CustomerAddress from './CustomerAddress';
import CustomerDeliveryAddress from './CustomerDeliveryAddress';
import CustomerName from './CustomerName';
import DeliveryDate from './DeliveryDate';
import Gross from './Gross';
import IssueDate from './IssueDate';
import NavId from './NavId';
import NavStatus from './NavStatus';
import Net from './Net';
import PaymentDate from './PaymentDate';
import VatValue from './VatValue';
import Outstanding from './Outstanding';

export const labels = {
  Id: 'Azonosító',
  Currency: 'Pénznem',
  CustomerName: 'Vevő neve',
  CustomerAddress: 'Vevő számlázási címe',
  CustomerDeliveryAddress: 'Vevő szállítási címe',
  InvoiceNumber: 'Szamlaszám',
  IssueDate: 'Kiállítás dátuma',
  DeliveryDate: 'Teljesítés dátuma',
  PaymentDate: 'Fizetési határidő',
  Status: 'Státusz',
  Net: 'Nettó ár',
  Gross: 'Bruttó ár',
  VatValue: 'ÁFA értéke',
  PaymentMethod: 'Fizetési mód',
  Type: 'Típus',
  CreatorUser: 'Rögzítette',
  Created: 'Létrehozva',
  LatestPaymentDate: 'Kiegyenlítve',
  NavId: 'NAV azonosító',
  NavStatus: 'NAV státusz',
  Updated: 'Módosítva',
  Outstanding: 'Kintlévőség',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'InvoiceNumber',
  fixed: true,
}, {
  value: 'Type',
}, {
  value: 'Currency',
}, {
  value: 'CustomerAddress',
}, {
  value: 'CustomerDeliveryAddress',
}, {
  value: 'CustomerName',
}, {
  value: 'DeliveryDate',
}, {
  value: 'Gross',
}, {
  value: 'IssueDate',
}, {
  value: 'NavId',
}, {
  value: 'NavStatus',
}, {
  value: 'Net',
}, {
  value: 'PaymentDate',
}, {
  value: 'VatValue',
}, {
  value: 'LatestPaymentDate',
}, {
  value: 'PaymentMethod',
}, {
  value: 'CreatorUser',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
},{
  value: 'Outstanding'
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'InvoiceNumber',
  fixed: true,
}, {
  value: 'Status',
}, {
  value: 'Type',
}, {
  value: 'PaymentMethod',
}, {
  value: 'Outstanding',
}, {
  value: 'LatestPaymentDate',
}, {
  value: 'IssueDate',
}, {
  value: 'CustomerName',
}, {
  value: 'Net',
}, {
  value: 'VatValue',
}, {
  value: 'Gross',
}, {
  value: 'NavStatus',
}, {
  value: 'Created',
}, {
  value: 'CreatorUser',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  InvoiceNumber,
  Type,
  Status,
  PaymentMethod,
  CustomerDeliveryAddress,
  LatestPaymentDate,
  InvoiceDates,
  CreatorUser,
  Created,
  Updated,
  Currency,
  CustomerAddress,
  CustomerName,
  DeliveryDate,
  Gross,
  IssueDate,
  NavId,
  NavStatus,
  Net,
  PaymentDate,
  VatValue,
  Outstanding,
};
